module.exports = __webpack_public_path__ + "img/bigbass.dc977ea1.gif";